import React from 'react'
import ReactDOM from 'react-dom/client'
import { HomePage } from './pages/HomePage'
import { LoginPage } from './pages/LoginPage'
import { isAuthenticated } from './api/authApi'
import './styles/tailwind.css'
import './styles/ai-mapping.css'
import './styles/modal.css'

const root = ReactDOM.createRoot(document.getElementById('root')!)

function App() {
    const [authed, setAuthed] = React.useState(isAuthenticated());

    if (!authed) {
        return <LoginPage onLogin={() => setAuthed(true)} />;
    }

    return <HomePage />;
}

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)
